const routes = [
  {
    path: '/personAuthorizationOld', // 人员通行授权
    name: 'personAuthorization',
    component: () => import('./pages/Home'),
    redirect: '/personAuthorization/index',
    meta: {
      requireAuth: false
    },
    children: [
      {
        path: 'index', // 
        name: 'authorizationIndex',
        component: () => import('./pages/index'),
        meta: {
          requireAuth: false,
          routerAlive: true
        }
      },
      {
        path: 'indexOld', // 
        name: 'personAuthorizationIndexOld',
        component: () => import('./pages/indexOld'),
        meta: {
          requireAuth: false,
          routerAlive: true
        }
      },
    ]
  }
]

export default routes